import type { ReviewImage } from './reviewImages';

/** Images are never sent with an appeal accept, so accept is blocked while any are attached. */
export function canAcceptAppealWithImages(images: ReviewImage[] | null | undefined): boolean {
  return !images || images.length === 0;
}
